import type { AssetFamilyContributor } from '~/modules/artist-roster/lib/types';

/**
 * This function takes a YYYY-MM-DD date string and an optional locale string,
 * and returns the date formatted according to the specified locale.
 * @param dateString Date string in ISO format (YYYY-MM-DD)
 * @param locale Browser locale, e.g. 'en-US', 'es-MX', 'fr-CA'
 * @returns Formatted date string in the specified locale.
 */
export function formatDateByLocale(
  dateString = '',
  { locale = navigator.language }: { locale?: string } = {},
) {
  if (!dateString) {
    return '';
  }

  const date = new Date(dateString + 'T00:00:00Z'); // UTC midnight.

  const formatter = new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    timeZone: 'UTC', // Force UTC to avoid local timezone effects.
  });

  return formatter.format(date);
}

export function getContributorsByRole(
  contributors: AssetFamilyContributor[],
  role: string,
) {
  return contributors.filter(({ categories }) => categories.includes(role));
}

export function getBenchmarkComparisonPercentage(
  streams: number,
  benchmark: number,
): number {
  return Math.round(((streams - benchmark) / benchmark) * 100);
}
